import { render, staticRenderFns } from "./HeaderNavTab.vue?vue&type=template&id=5b6b0fc4&"
import script from "./HeaderNavTab.vue?vue&type=script&lang=js&"
export * from "./HeaderNavTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports